<template>
  <div
    class="relative laptop:col-span-2 largeDesktop:col-span-1  bg-[#fff] tablet:max-w-[400px] tablet:mx-auto largeDesktop:max-w-[500px]"
    :class="{ 'p-[20px] tablet:p-[30px] largeDesktop:p-[50px]  rounded-[20px] shadow-[0px_0px_20px_0px_#00000026]': mode != 'modal' }">
    <h4 v-if="mode != 'modal'" class="text-[20px] font-normal font-days text-[#333]">Welcome to</h4>
    <h4 v-if="mode != 'modal'" class="w-max relative text-[24px] font-normal font-days text-[#2459A8]"><span
        class="text-[#F5B134]">My</span>HappyHome
        <!-- <img src="../../assets/images/tm-icon.svg" alt="Trademark Icon"
        class="w-[20px] h-[20px] absolute top-[3px] -right-[25px]"> -->
    </h4>
    <div class="flex flex-col gap-[10px] largeDesktop:gap-[15px] my-[20px] tablet:my-[30px] laptop:my-[10px]">
      <h2 v-if="mode != 'modal'" class="text-[24px] largeDesktop:text-[40px] font-semibold font-poppins text-[#000]">
        Sign
        in</h2>
      <p class="text-[14px] largeDesktop:text-[16px] font-normal font-poppins text-[#666]">Sign in to manage your
        coverage, services, and
        claims in one place.</p>
      <div class="flex items-center justify-center gap-[15px]">

        <button @click="loginWithGoogle"
          class="flex items-center justify-center w-full gap-[8px] tablet:gap-[10px] text-[#448AFF] p-[8px] rounded-[5px] bg-[#2459A8] bg-opacity-[8%] min-w-[49%]">
          <img src="../../assets/images/google-icon.svg" alt="Facebook icon"
            class="w-[20px] h-[20px] largeDesktop:w-[24px] largeDesktop:h-[24px]">
          <span class="text-[#448AFF] font-poppins text-[13px] largeDesktop:text-sm">Google Sign In</span>
        </button>
        <!-- <button :disabled="loading" @click="loginWithFacebook"
          class="flex items-center gap-[8px] tablet:gap-[10px] p-[8px] rounded-[5px] bg-[#2459A8] bg-opacity-[8%] min-w-[49%]">
          <img src="../../assets/images/facebookIcon.svg" alt="Facebook icon"
            class="w-[20px] h-[20px] largeDesktop:w-[24px] largeDesktop:h-[24px]">
          <span class="text-[#2459A8] font-poppins text-[13px] largeDesktop:text-sm">Facebook Login</span>
        </button> -->
      </div>
    </div>
    <div class="form-group">
      <label for="phoneNumber"
        class="!text-[14px] largeDesktop:!text-[16px] font-poppins font-normal mb-1 text-[#666666]">Phone
        Number<span class="text-[#F00]">*</span></label>
      <inputComponent ref="phoneRef" v-model="phone" name="phone" required errorClass="!text-[#117EC2]" type="tel"
        error-message="Please enter a valid Phone number" placeholder="(xxx) xxx - xxxx" mask="(###) ###-####"
        customClass="border-[1px] !border-[#CCCCCC] !text-[14px] largeDesktop:!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px] placeholder:!text-[#999]" />
    </div>
    <div class="flex pt-[20px] largeDesktop:pt-[30px] pb-[20px]">
      <button :disabled="isSubmitDisabled()"
        class="CustomYellowBtn px-[40px] largeDesktop:px-[50px] py-[8px] largeDesktop:py-2.5 rounded-full uppercase font-poppins font-medium text-[16px] largeDesktop:text-[18px] w-max mx-auto  disabled:border-[#efefef] disabled:bg-gradient-to-r disabled:from-[#EFEFEF]  disabled:to-[#EFEFEF] disabled:hover:bg-gradient-to-r disabled:hover:from-[#EFEFEF] disabled:hover:to-[#EFEFEF] disabled:!text-[#999] focus:outline-none "
        type="submit" @click="loginClicked()">
        Continue
      </button>
    </div>
    <div
      class="pt-[10px] pb-[20px] largeDesktop:pt-[20px] largeDesktop:pb-[30px] flex flex-col items-center gap-[10px] border-t border-[#EFEFEF]">
      <p class="text-[12px] font-poppins text-[#999999]">Don't have an account?</p>
      <button @click="creatAccountClicked"
        class="CustomBlueBtn px-[54px] py-[8px] font-normal text-[14px] font-poppins rounded-[5px] !border-[1px] !border-customBlue-100 laptop:hover:!text-white !bg-transparent !text-customBlue-100 cursor-pointer focus:outline-none ">
        Register Now
      </button>
    </div>
    <copyright />
    <div class="col-span-2 mt-[5px]">
      <termsAndPrivacyComponent />
    </div>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters
} from "vuex";
import inputComponent from '../../components/partialComponent/inputComponent.vue';
import { getBrowserFingerprint } from '@/helpers/fingerprint';
import copyright from "../../views/nest_views/copyright.vue";
import { useToast } from 'vue-toastification';
const toast = useToast();
import termsAndPrivacyComponent from "./termsAndPrivacyComponent.vue";
export default {
  props: ["callbacks", "mode"],
  components: {
    inputComponent,
    copyright,
    termsAndPrivacyComponent,
  },
  data() {
    return {
      phone: '',
      passwordVisible: false,
      fingerprint: '',
      loading: false,
      user: null,
    };
  },

  watch: {
    socialUserResponse: function () {
      if (this.socialUserResponse.requires_registration) {
        localStorage.setItem('registerFormData', JSON.stringify({
          "email": this.socialUserResponse.profile.email,
          "first_name": this.socialUserResponse.profile.first_name,
          "last_name": this.socialUserResponse.profile.last_name,
          "provider": this.socialUserResponse.provider,
          "provider_id": this.socialUserResponse.provider_id,
        }));
        if (this.callbacks) {
          this.callbacks("register")
        }
      } else if (!this.socialUserResponse.otp_verified) {
        this.phone = this.socialUserResponse.profile.phone.replaceAll("+1", "")
        this.requestOtp({
          phone: this.$helper.extractPhoneNumber(this.phone)
        })
      } else {
        let user = JSON.parse(localStorage.getItem('user')) ?? {}
        user['_token'] = this.socialUserResponse._token
        localStorage.setItem('user', JSON.stringify(user))

        this.getProfile({
          is_show: true
        })
      }
    },

    requestOtpResponse: function () {
      if (this.requestOtpResponse != null) {

        if (this.requestOtpResponse.status == true) {
          localStorage.setItem('registerFormData', JSON.stringify({
            phone: this.phone
          }));
          toast.success(this.requestOtpResponse.message)
          if (this.callbacks) {
            this.callbacks("verification")
          }
        } else {
          toast.error(this.requestOtpResponse.message)
        }
      }
    },

    userObject: function () {
      if (this.userObject != 'undefined') {
        localStorage.removeItem('registerFormData')
        localStorage.setItem('user', JSON.stringify(this.userObject))
        this.consumerCartUpdate({})
      }
    },

    consumerCartUpdateResponse: function () {
      if (this.callbacks) {
        this.callbacks("verified")
      }
    },
  },

  computed: {
    ...mapGetters(["requestOtpResponse", "socialUserResponse", "userObject", "consumerCartUpdateResponse"]),
  },

  async created() {
    this.fingerprint = await getBrowserFingerprint();
  },

  async mounted() {
    const checkFB = setInterval(() => {
      if (window.FB) {
        this.fbLoaded = true;
        clearInterval(checkFB);
        console.log('FB object ready');
      }
    }, 50);
  },


  methods: {
    ...mapActions(["requestOtp", "checkSocialUser", "getProfile", "consumerCartUpdate"]),

    loginWithGoogle() {
      const client = google.accounts.oauth2.initTokenClient({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        scope: 'email profile',
        callback: (response) => {
          if (response?.access_token) {
            this.checkSocialUser({
              "provider": "google",
              "access_token": response.access_token
            })
          }
        },
      })

      client.requestAccessToken()
    },

    contractorAgreementClicked() {
      this.$router.push({
        name: 'termsAndConditions',
      });
    },

    privacyPolicyClicked() {
      this.$router.push({
        name: 'privacyPolicy',
      });
    },

    isSubmitDisabled() {

      if (this.phone.length == 14) {
        return false
      } else {
        return true
      }
    },

    loginClicked() {
      this.requestOtp({
        phone: this.$helper.extractPhoneNumber(this.phone)
      })
    },

    creatAccountClicked() {
      localStorage.removeItem('registerFormData');
      if (this.callbacks) {
        this.callbacks("register")
      }
    },

    loginWithFacebook() {
      if (!this.fbLoaded) {
        console.log('Facebook SDK not ready yet');
        return;
      }

      FB.login(
        (response) => {
          if (response.authResponse) {
            const token = response.authResponse.accessToken;
            console.log('FB Token:', token);
            this.checkSocialUser({
              "provider": "facebook",
              "access_token": token
            })

          } else {
            console.log('User cancelled login');
          }
        },
        { scope: 'public_profile,email' }
      );
    },

  },

};
</script>